module.exports = __webpack_public_path__ + "img/alexa.ee794699.png";